
import { auth, df } from '@/plugins/firebase'
import state from '@/state'
import { initPrintManager } from '@/libs/jsPrintManager/utils'
import { printerInit } from '@/libs/bixolon/printer'
import { loadScript } from 'vue-plugin-load-script'

export default {
  name: 'pointOfSale',
  path: '/companies/:companyId/locations/:locationId',
  beforeEnter: async (to, from, next) => {
    if (to.params.companyId === state.getCurrentCompany().id && to.params.locationId === state.getPointOfSale().id) {
      state.setAppTitle(state.getPointOfSale().name)
      next()
    } else {
      const companies = await df.doc(`user_companies/${auth.currentUser.uid}`).get()
      if (
        !companies ||
        !companies.exists ||
        !companies.data() ||
        Object.keys(companies.data().companies).length < 1 ||
        !companies.data().companies[to.params.companyId] ||
        companies.data().companies[to.params.companyId].status !== 'OK'
      ) {
        next({ name: 'catchall' })
        return
      }
      const company = companies.data().companies[to.params.companyId]
      const pointsOfSale = await df.doc(`user_locations/${auth.currentUser.uid}.${company.id}`).get()
      if (
        !pointsOfSale ||
        !pointsOfSale.data() ||
        !pointsOfSale.data().locations ||
        Object.keys(pointsOfSale.data().locations).length < 1 ||
        !pointsOfSale.data().locations[to.params.locationId] ||
        pointsOfSale.data().locations[to.params.locationId].status !== 'OK' ||
        Object.keys(pointsOfSale.data().locations).map(key => {
          return pointsOfSale.data().locations[key]
        })[0].resource_status !== 'ACTIVE'
      ) {
        next({ name: 'catchall' })
        return
      }
      const pointOfSale = pointsOfSale.data().locations[to.params.locationId]

      // Fetch additional company details including eRacun configuration
      try {
        const companyDetails = await df.doc(`companies/${to.params.companyId}`).get()
        if (companyDetails.exists) {
          const companyData = companyDetails.data()
          // Merge eRacun configuration from companies collection
          if (companyData.eracun) {
            company.eracun = companyData.eracun
          }
        }
      } catch (error) {
        console.warn('Could not fetch company details:', error)
      }

      state.setCurrentCompany(company)
      state.setAppTitle(pointOfSale.name)
      state.setPointOfSale(pointOfSale)

      console.log(`🔵 [router] Ulazim na prodajno mjesto: ${pointOfSale.name}`)

      // Initialize printer libraries only if order print location is already configured
      const orderPrintLocation = state.getOrderPrintLocation()
      console.log(`🔵 [router] Na njemu se printaju narudzbe za prodajno mjesto: ${orderPrintLocation ? orderPrintLocation.name : 'NIJE POSTAVLJENO'}`)

      if (orderPrintLocation && orderPrintLocation.id) {
        const printerLib = state.getPrinterLib()
        console.log(`🔵 [router] Printer biblioteka: ${printerLib}`)

        if (printerLib === 'UNIVERSAL') {
          const isInitialized = window.Neodynamic && window.Neodynamic.JSESCPOSBuilder
          console.log(`🔵 [router] Trenutno inicijaliziran JSESCPOSBuilder: ${isInitialized ? 'Da' : 'Ne'}`)

          if (!isInitialized) {
            console.log('🔵 [router] Inicijaliziram JSESCPOSBuilder - pozivam initPrintManager()')
            initPrintManager()
          }
        } else if (printerLib === 'BIXOLON80') {
          const isInitialized = window.jscpos && window.jscpos.USBDevice
          console.log(`🔵 [router] Trenutno inicijaliziran jscpos: ${isInitialized ? 'Da' : 'Ne'}`)

          if (!isInitialized) {
            console.log('🔵 [router] Inicijaliziram jscpos - pozivam printerInit(1)')
            const issueID = 1
            printerInit(issueID)
          }
        }
      }

      next()
    }
  },
  redirect: (to) => {
    if (to.path === `/companies/${to.params.companyId}/locations/${to.params.locationId}`) {
      return `/companies/${to.params.companyId}/locations/${to.params.locationId}/registers`
    } else {
      return to.path
    }
  },
  meta: {
    requiresAuth: true
  },
  component: () => import(/* webpackChunkName: "CashRegisters" */ '@/modules/point-of-sale/PointOfSale'),
  children: [
    {
      path: '/companies/:companyId/locations/:locationId/registers',
      name: 'pointOfSale.cashRegisters',
      beforeEnter: (to, from, next) => {
        const pointOfSale = state.getPointOfSale()
        console.log(`🔵 [router/registers] Ulazim na prodajno mjesto: ${pointOfSale ? pointOfSale.name : 'NIJE POSTAVLJENO'}`)

        // Initialize printer libraries only if order print location is already configured
        const orderPrintLocation = state.getOrderPrintLocation()
        console.log(`🔵 [router/registers] Na njemu se printaju narudzbe za prodajno mjesto: ${orderPrintLocation ? orderPrintLocation.name : 'NIJE POSTAVLJENO'}`)

        if (orderPrintLocation && orderPrintLocation.id) {
          const printerLib = state.getPrinterLib()
          console.log(`🔵 [router/registers] Printer biblioteka: ${printerLib}`)

          if (printerLib === 'UNIVERSAL') {
            const isInitialized = window.Neodynamic && window.Neodynamic.JSESCPOSBuilder
            console.log(`🔵 [router/registers] Trenutno inicijaliziran JSESCPOSBuilder: ${isInitialized ? 'Da' : 'Ne'}`)

            if (!isInitialized) {
              console.log('🔵 [router/registers] Inicijaliziram JSESCPOSBuilder - učitavam skripte...')
              loadScript('https://firebasestorage.googleapis.com/v0/b/ai-fisk-stage/o/javascript%2Fcptable.js?alt=media&token=2bbbaafa-5866-4acd-8e7f-7ad119399288')
                .then(() => {
                  console.log('🔵 [router/registers] cptable.js učitan')
                  return loadScript('https://firebasestorage.googleapis.com/v0/b/ai-fisk-stage/o/javascript%2Fcputils.js?alt=media&token=aa7abbec-5afa-43d1-b052-e0df13527090')
                })
                .then(() => {
                  console.log('🔵 [router/registers] cputils.js učitan')
                  return loadScript('https://firebasestorage.googleapis.com/v0/b/ai-fisk-stage/o/javascript%2FJSESCPOSBuilder.js?alt=media&token=711f55f8-3128-473c-9e83-52c472ac0a42')
                })
                .then(() => {
                  console.log('🔵 [router/registers] JSESCPOSBuilder.js učitan - pozivam initPrintManager()')
                  initPrintManager()
                })
                .catch((error) => {
                  console.error('🔴 [router/registers] Greška pri učitavanju skripti:', error)
                })
            } else {
              console.log('🔵 [router/registers] JSESCPOSBuilder već učitan - pozivam samo initPrintManager()')
              initPrintManager()
            }
          } else if (printerLib === 'BIXOLON80') {
            const isInitialized = window.jscpos && window.jscpos.USBDevice
            console.log(`🔵 [router/registers] Trenutno inicijaliziran jscpos: ${isInitialized ? 'Da' : 'Ne'}`)

            if (!isInitialized) {
              console.log('🔵 [router/registers] Inicijaliziram jscpos - pozivam printerInit(1)')
              const issueID = 1
              printerInit(issueID)
            }
          }
        }

        next()
      },
      meta: {
        title: '$vuetify.pointsOfSaleTabs.registers',
        addItemText: '$vuetify.pointOfSale.addRegisterBtn',
        addItemAction: 'openAddRegisterForm',
        requiresAuth: true,
        filterSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "PriceList" */ '@/modules/point-of-sale/components/cash-registers/CashRegisters')
    },
    {
      path: '/companies/:companyId/locations/:locationId/price-list',
      name: 'pointOfSale.priceList',
      meta: {
        title: '$vuetify.pointsOfSaleTabs.priceList',
        addItemText: '$vuetify.pointOfSale.addPricelistItemBtn',
        addItemAction: 'openAddPricelistItemForm',
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "PriceList" */ '@/modules/point-of-sale/components/price-list/PriceList')
    },
    {
      path: '/companies/:companyId/locations/:locationId/warehouse',
      name: 'pointOfSale.warehouse',
      meta: {
        title: '$vuetify.pointsOfSaleTabs.warehouse',
        addItemText: '$vuetify.pointOfSale.addWarehouseItemBtn',
        addItemAction: 'openAddWarehouseItemForm',
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/Warehouse')
    },
    {
      path: '/companies/:companyId/locations/:locationId/items',
      name: 'pointOfSale.items',
      meta: {
        title: '$vuetify.pointsOfSaleTabs.lager',
        addItemText: '$vuetify.pointOfSale.addLagerItemBtn',
        addItemAction: 'openaddItemForm',
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/items/lager',
      name: 'pointOfSale.items.lager',
      meta: {
        title: '$vuetify.pointsOfSaleTabs.lager',
        addItemText: '$vuetify.pointOfSale.addLagerItemBtn',
        addItemAction: 'openaddItemForm',
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Lager" */ '@/modules/company/components/lager/Lager')
    },
    {
      path: '/companies/:companyId/locations/:locationId/items/upload',
      name: 'pointOfSale.items.upload',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/company/components/lager/UploadItems'),
      meta: {
        title: '$vuetify.uploadItems.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/items/discount',
      name: 'pointOfSale.items.discount',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/company/components/discount/Discount'),
      meta: {
        title: '$vuetify.discount.titleText',
        addItemText: '$vuetify.company.addDiscountBtn',
        addItemAction: 'openaddDiscount',
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/items/categories',
      name: 'pointOfSale.items.categories',
      meta: {
        title: '$vuetify.companyTabs.categories',
        addItemText: '$vuetify.pointOfSale.addCategory',
        addItemAction: 'openAddCategoryForm',
        requiresAuth: true,
        filterSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Categories" */ '@/modules/company/components/categories/Categories')
    },
    {
      path: '/companies/:companyId/locations/:locationId/items/kpd-sifra',
      name: 'pointOfSale.items.kpd',
      meta: {
        title: 'KPD Šifre',
        noAddButton: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "KpdSifra" */ '@/modules/company/components/kpd-sifra/KpdSifra')
    },
    {
      path: '/companies/:companyId/locations/:locationId/items/declarations',
      name: 'pointOfSale.items.declarations',
      meta: {
        title: '$vuetify.declarations.titleText',
        noAddButton: true,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Declarations" */ '@/modules/company/components/declarations/Declarations')
    },
    {
      path: '/companies/:companyId/locations/:locationId/receipts',
      name: 'pointOfSale.receipts',
      meta: {
        title: '$vuetify.pointsOfSaleTabs.receipts',
        noAddButton: true,
        requiresAuth: true,
        removeSearch: true,
        removeGrid: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Lager" */ '@/modules/company/components/receipts/Receipts')
    },
    {
      path: '/companies/:companyId/locations/:locationId/associates',
      name: 'pointOfSale.associates',
      meta: {
        title: '$vuetify.pointsOfSaleTabs.associates',
        addItemText: '$vuetify.pointOfSale.addAssociateBtn',
        addItemAction: 'addAssociate',
        requiresAuth: true,
        filterSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Lager" */ '@/modules/company/components/associates/Associates')
    },
    {
      path: '/companies/:companyId/locations/:locationId/users',
      name: 'pointOfSale.users',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/companies/components/users/Users'),
      meta: {
        title: '$vuetify.users.titleText',
        addItemText: '$vuetify.users.addUser',
        addItemAction: 'addUser',
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/reports',
      name: 'pointOfSale.reports',
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/reports/reportPosd',
      name: 'pointOfSale.reports.reportPosd',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/companies/components/reports/ReportPosd'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/reports/reportKpr',
      name: 'pointOfSale.reports.reportKpr',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/companies/components/reports/ReportKpr'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/instructions',
      name: 'pointOfSale.instructions',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/companies/components/instructions/Instructions'),
      meta: {
        title: '$vuetify.instructions.titleText',
        filterSearch: false,
        requiresAuth: true,
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/warehouseItems',
      name: 'pointOfSale.warehouseModule.items',
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/warehouse-module/WarehouseItems'),
      meta: {
        noAddButton: true,
        title: '$vuetify.warehouse.titleText',
        addItemText: '$vuetify.warehouse.addItemsText',
        addItemAction: 'openAddWarehouseModuleItemForm',
        filterSearch: true,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/warehouseDocuments',
      name: 'pointOfSale.warehouseModule.documents',
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/warehouse-module/WarehouseDocuments'),
      meta: {
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        title: '$vuetify.warehouse.titleText',
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/items/norm',
      name: 'pointOfSale.items.norm',
      meta: {
        title: '$vuetify.companyTabs.norm',
        noAddButton: true,
        removeSearch: true,
        // addItemText: '$vuetify.company.addNormBtn',
        // addItemAction: 'openaddItemForm',
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Lager" */ '@/modules/company/components/norm/Norm')
    },
    {
      path: '/companies/:companyId/locations/:locationId/userdata/bill',
      name: 'pointOfSale.userData.bill',
      meta: {
        title: '$vuetify.userDataTabs.bill',
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Lager" */ '@/modules/company/components/userdata/Bill')
    },
    {
      path: '/companies/:companyId/locations/:locationId/userdata/qr-menu',
      name: 'pointOfSale.userData.qrMenu',
      meta: {
        title: 'QR Kod Meni',
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "QRMenu" */ '@/modules/company/components/userdata/QRMenu')
    },
    {
      path: '/companies/:companyId/locations/:locationId/close-balance',
      name: 'pointOfSale.closeBalance.displayCloseBalance',
      meta: {
        title: '$vuetify.userDataTabs.bill',
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Lager" */ '@/modules/point-of-sale/components/close-balance/DisplayCloseBalanceList')
    },
    {
      path: '/companies/:companyId/locations/:locationId/groupageColection',
      name: 'pointOfSale.reports.groupageColection',
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/companies/components/reports/GroupageCollection')
    },
    {
      path: '/companies/:companyId/locations/:locationId/restauraunt/menuItems',
      name: 'pointOfSale.restaurant.menuItems',
      component: () => import(/* webpackChunkName: "Restaraunt" */ '@/modules/point-of-sale/components/menu-item/MenuItems'),
      meta: {
        title: '$vuetify.restaurant.menu',
        filterSearch: false,
        requiresAuth: true,
        addItemAction: 'openAddMenuItem',
        addItemText: 'Dodaj meni',
        removeSearch: true,
        removeGrid: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/orders/createOrder',
      name: 'pointOfSale.orders.createOrder',
      component: () => import(/* webpackChunkName: "Orders" */ '@/modules/point-of-sale/components/orders/CreateOrder'),
      meta: {
        removeGrid: true,
        addItemText: '$vuetify.orders.createOrder',
        addItemAction: 'openCreateOrder',
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/orders/showOrders',
      name: 'pointOfSale.orders.showOrders',
      component: () => import(/* webpackChunkName: "Orders" */ '@/modules/point-of-sale/components/orders/ShowOrders'),
      meta: {
        removeGrid: true,
        addItemText: '$vuetify.orders.showOrders',
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/printerConfiguration',
      name: 'pointOfSale.printerConfiguration',
      component: () => import(/* webpackChunkName: "" */ '@/modules/point-of-sale/components/printer-configuration/PrinterConfiguration'),
      meta: {
        title: '$vuetify.printerConfig.title',
        filterSearch: false,
        requiresAuth: true,
        addItemAction: 'openAddPrinter',
        addItemText: 'Dodaj printer',
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/organizationalUnitConfiguration',
      name: 'pointOfSale.organizationalUnitConfiguration',
      component: () => import(/* webpackChunkName: "" */ '@/modules/point-of-sale/components/organizational-unit-configuration/OrganizationalUnitConfiguration'),
      meta: {
        title: '$vuetify.orgUnitConfig.title',
        filterSearch: false,
        requiresAuth: true,
        addItemAction: 'openAddOrgUnit',
        addItemText: 'Dodaj ustrojstvenu jedinicu',
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/suppliers',
      name: 'pointOfSale.suppliers',
      meta: {
        title: '$vuetify.companyTabs.suppliers',
        addItemText: '$vuetify.company.addSupplier',
        addItemAction: 'addSupplier',
        requiresAuth: true,
        filterSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import(/* webpackChunkName: "Lager" */ '@/modules/company/components/suppliers/Suppliers')
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/reportMenu',
      name: 'pointOfSale.all-reports.reportMenu',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/ReportMenu'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/recapitulation',
      name: 'pointOfSale.all-reports.recapitulation',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/RecapitulationTrade'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/recapitulationBuyers',
      name: 'pointOfSale.all-reports.recapitulationBuyers',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/RecapitulationBuyers'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/taxReport',
      name: 'pointOfSale.all-reports.taxReport',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/TaxReport'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/pnpReport',
      name: 'pointOfSale.all-reports.pnpReport',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/PnpReport'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/itemReport',
      name: 'pointOfSale.all-reports.itemReport',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/ItemReport'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/itemPricelistReport',
      name: 'pointOfSale.all-reports.itemPricelistReport',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/ItemPricelistReport'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/recapitulationTips',
      name: 'pointOfSale.all-reports.recapitulationTips',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/RecapitulationTips'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/recapitulationRmk',
      name: 'pointOfSale.all-reports.recapitulationRmk',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/RecapitulationRmk'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/knjigaPrometa',
      name: 'pointOfSale.all-reports.knjigaPrometa',
      component: () => import(/* webpackChunkName: "KnjigaPrometa" */ '@/modules/all-reports/KnjigaPrometa'),
      meta: { title: '$vuetify.reports.titleText', noAddButton: true, filterSearch: false, requiresAuth: true, sideNav: 'PointOfSale', topBar: 'PointOfSaleTopBar' }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/nivelacija',
      name: 'pointOfSale.all-reports.nivelacija',
      component: () => import(/* webpackChunkName: "Nivelacija" */ '@/modules/all-reports/Nivelacija'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/inventories',
      name: 'pointOfSale.all-reports.inventories',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/Inventories'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/warehouseCard',
      name: 'pointOfSale.all-reports.warehouseCard',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/WarehouseCard'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/groupageCollection',
      name: 'pointOfSale.all-reports.groupageCollection',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/GroupageCollection'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/customerCard',
      name: 'pointOfSale.all-reports.customerCard',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/CustomerCard'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/recapitulationVirmans',
      name: 'pointOfSale.all-reports.recapitulationVirmans',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/all-reports/RecapitulationVirmans'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/statistikeProhoda',
      name: 'pointOfSale.all-reports.statistikeProhoda',
      component: () => import(/* webpackChunkName: "StatistikeProhoda" */ '@/modules/all-reports/StatistikeProhoda'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/heatmapProhoda',
      name: 'pointOfSale.all-reports.heatmapProhoda',
      component: () => import(/* webpackChunkName: "HeatmapProhoda" */ '@/modules/all-reports/HeatmapProhoda'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/usporedbaGodina',
      name: 'pointOfSale.all-reports.usporedbaGodina',
      component: () => import(/* webpackChunkName: "UsporedbaGodina" */ '@/modules/all-reports/UsporedbaGodina'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/promZaposlenika',
      name: 'pointOfSale.all-reports.promZaposlenika',
      component: () => import(/* webpackChunkName: "PromZaposlenika" */ '@/modules/all-reports/PromZaposlenika'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/usporedbaPoTjednima',
      name: 'pointOfSale.all-reports.usporedbaPoTjednima',
      component: () => import(/* webpackChunkName: "UsporedbaPoTjednima" */ '@/modules/all-reports/UsporedbaPoTjednima'),
      meta: { title: '$vuetify.reports.titleText', noAddButton: true, filterSearch: false, requiresAuth: true, sideNav: 'PointOfSale', topBar: 'PointOfSaleTopBar' }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/smjeneProhoda',
      name: 'pointOfSale.all-reports.smjeneProhoda',
      component: () => import(/* webpackChunkName: "SmjeneProhoda" */ '@/modules/all-reports/SmjeneProhoda'),
      meta: { title: '$vuetify.reports.titleText', noAddButton: true, filterSearch: false, requiresAuth: true, sideNav: 'PointOfSale', topBar: 'PointOfSaleTopBar' }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/stornoAnaliza',
      name: 'pointOfSale.all-reports.stornoAnaliza',
      component: () => import(/* webpackChunkName: "StornoAnaliza" */ '@/modules/all-reports/StornoAnaliza'),
      meta: { title: '$vuetify.reports.titleText', noAddButton: true, filterSearch: false, requiresAuth: true, sideNav: 'PointOfSale', topBar: 'PointOfSaleTopBar' }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/napojniceReport',
      name: 'pointOfSale.all-reports.napojniceReport',
      component: () => import(/* webpackChunkName: "NapojniceReport" */ '@/modules/all-reports/NapojniceReport'),
      meta: { title: '$vuetify.reports.titleText', noAddButton: true, filterSearch: false, requiresAuth: true, sideNav: 'PointOfSale', topBar: 'PointOfSaleTopBar' }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/kdsReport',
      name: 'pointOfSale.all-reports.kdsReport',
      component: () => import(/* webpackChunkName: "KdsReport" */ '@/modules/all-reports/KdsReport'),
      meta: {
        title: '$vuetify.reports.titleText',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/all-reports/automatski-slanje',
      name: 'pointOfSale.all-reports.automatski-slanje',
      component: () => import(/* webpackChunkName: "AutomatskiSlanje" */ '@/modules/all-reports/AutomatskiSlanje'),
      meta: {
        title: 'Automatsko slanje izvještaja',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/warehouseDocumentsOverview',
      name: 'pointOfSale.warehouseModule.warehouseDocumentsOverview',
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/warehouse-module/WarehouseDocumentsOverview'),
      meta: {
        removeGrid: true,
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/suppliers/supplierItems',
      name: 'pointOfSale.suppliers.supplierItems',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/company/components/suppliers/SupplierItems'),
      meta: {
        title: '$vuetify.companyTabs.items',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/suppliers/supplierItemsUpload',
      name: 'pointOfSale.suppliers.supplierItemsUpload',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/company/components/suppliers/SupplierItemsUpload'),
      meta: {
        title: '$vuetify.companyTabs.items',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/orders/receiveOrder',
      name: 'pointOfSale.orders.receiveOrder',
      component: () => import(/* webpackChunkName: "Orders" */ '@/modules/point-of-sale/components/orders/other/receive-order/ReceiveOrderOther'),
      meta: {
        removeGrid: true,
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/suppliers/supplierIntegrations',
      name: 'pointOfSale.suppliers.supplierIntegrations',
      component: () => import('@/modules/company/components/suppliers/integration/SupplierIntegrations'),
      meta: {
        filterSearch: false,
        requiresAuth: true,
        addItemText: '$vuetify.company.addIntegration',
        addItemAction: 'addIntegration',
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/suppliers/supplierItemsPriceUpload',
      name: 'pointOfSale.suppliers.supplierItemsPriceUpload',
      component: () => import(/* webpackChunkName: "Users" */ '@/modules/company/components/suppliers/SupplierItemsPriceUpload'),
      meta: {
        title: '$vuetify.companyTabs.items',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        labelText: '$vuetify.users.searchLabelText',
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/posConfiguration',
      name: 'pointOfSale.posConfiguration',
      component: () => import(/* webpackChunkName: "" */ '@/modules/point-of-sale/components/pos-configuration/PosConfiguration'),
      meta: {
        title: '$vuetify.posConfig.title',
        filterSearch: false,
        requiresAuth: true,
        addItemAction: 'openAddPos',
        addItemText: 'Dodaj pos',
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/cardConfiguration',
      name: 'pointOfSale.cardConfiguration',
      component: () => import(/* webpackChunkName: "" */ '@/modules/point-of-sale/components/card-configuration/CardConfiguration'),
      meta: {
        title: '$vuetify.cardConfig.title',
        filterSearch: false,
        requiresAuth: true,
        addItemAction: 'openAddCard',
        addItemText: 'Dodaj karticu',
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/activeInventory',
      name: 'pointOfSale.warehouseModule.activeInventory',
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/warehouse-module/Inventura/ActiveInventory'),
      meta: {
        title: '$vuetify.inventura.active',
        removeGrid: true,
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/inventories',
      name: 'pointOfSale.warehouseModule.inventories',
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/warehouse-module/Inventura/Inventories'),
      meta: {
        title: '$vuetify.inventura.title',
        removeGrid: true,
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/communicationConfiguration',
      name: 'pointOfSale.communicationConfiguration',
      component: () => import(/* webpackChunkName: "" */ '@/modules/point-of-sale/components/communication-configuration/CommunicationConfiguration'),
      meta: {
        title: '$vuetify.communicationConfig.title',
        filterSearch: false,
        requiresAuth: true,
        addItemAction: 'openAddCommunication',
        addItemText: '$vuetify.add',
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/floorPlanSettings',
      name: 'pointOfSale.floorPlanSettings',
      component: () => import(/* webpackChunkName: "FloorPlan" */ '@/modules/point-of-sale/components/floor-plan-settings/FloorPlanSettings'),
      meta: {
        title: '$vuetify.floorPlan.title',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/notifications',
      name: 'pointOfSale.notifications',
      component: () => import(/* webpackChunkName: "" */ '@/modules/company/components/notifications/Notifications'),
      meta: {
        title: '$vuetify.notifications.title',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/admin/companySettings',
      name: 'pointOfSale.admin.companySettings',
      component: () => import(/* webpackChunkName: "" */ '@/modules/company/components/admin/CompanySettings'),
      meta: {
        title: '$vuetify.companySettings.title',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/admin/companyWarehouseModule',
      name: 'pointOfSale.admin.companyWarehouseModule',
      component: () => import(/* webpackChunkName: "" */ '@/modules/company/components/admin/CompanyWarehouseModule'),
      meta: {
        title: '$vuetify.companyWarehouseModule.title',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/staff',
      name: 'pointOfSale.workOrder.staff',
      component: () => import(/* webpackChunkName: "" */ '@/modules/point-of-sale/components/workorder/WorkOrderStaff'),
      meta: {
        title: '$vuetify.workorder.staff',
        addItemAction: 'openAddStaff',
        addItemText: '$vuetify.add',
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/admin/companyAdd',
      name: 'pointOfSale.admin.companyAdd',
      component: () => import(/* webpackChunkName: "" */ '@/modules/company/components/admin/CompanyAdd'),
      meta: {
        title: '$vuetify.companyAdd.title',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/fields',
      name: 'pointOfSale.workOrder.fields',
      component: () => import(/* webpackChunkName: "" */ '@/modules/point-of-sale/components/workorder/WorkOrderFields'),
      meta: {
        title: '$vuetify.workorder.fields',
        addItemAction: 'openAddField',
        addItemText: '$vuetify.add',
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/warehouseDocumentsv2',
      name: 'pointOfSale.warehouseModule.documentsv2',
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/warehouse-module/WarehouseDocumentsv2'),
      meta: {
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        title: '$vuetify.warehouse.titleText',
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/kalkulacija',
      name: 'pointOfSale.warehouseModule.kalkulacija',
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/warehouse-module/Kalkulacija'),
      meta: {
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        title: 'Kalkulacija',
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/workorders',
      name: 'pointOfSale.workOrders',
      component: () => import(/* webpackChunkName: "" */ '@/modules/point-of-sale/components/workorder/WorkOrders'),
      meta: {
        title: '$vuetify.workorders',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/incoming-einvoices',
      name: 'pointOfSale.incoming-einvoices',
      meta: {
        title: '$vuetify.companyTabs.incomingEinvoices',
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import('@/modules/company/components/einvoices/Incoming.vue')
    },
    {
      path: '/companies/:companyId/locations/:locationId/outgoing-einvoices',
      name: 'pointOfSale.outgoing-einvoices',
      meta: {
        title: '$vuetify.companyTabs.outgoingEinvoices',
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import('@/modules/company/components/einvoices/Outgoing.vue')
    },
    {
      path: '/companies/:companyId/locations/:locationId/production',
      name: 'pointOfSale.production',
      meta: {
        title: 'Proizvodnja',
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import('@/modules/point-of-sale/components/warehouse/warehouse-module/Production.vue')
    },
    {
      path: '/companies/:companyId/locations/:locationId/normative-production',
      name: 'pointOfSale.normativeProduction',
      meta: {
        title: 'Proizvodnja dan',
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import('@/modules/point-of-sale/components/warehouse/warehouse-module/NormativeProduction.vue')
    },
    {
      path: '/companies/:companyId/locations/:locationId/ispravak-normativa',
      name: 'pointOfSale.warehouseModule.ispravakNormativa',
      meta: {
        title: 'Ispravak normativa',
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      },
      component: () => import('@/modules/point-of-sale/components/warehouse/warehouse-module/IspravakNormativa.vue')
    },
    {
      path: '/companies/:companyId/locations/:locationId/fiscalizationEracun',
      name: 'pointOfSale.fiscalizationEracun',
      component: () => import(/* webpackChunkName: "FiscalizationEracun" */ '@/modules/company/components/fiscalization-eracun/FiscalizationEracun'),
      meta: {
        title: 'Fiskalizacija i E-račun',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/businessSettings',
      name: 'pointOfSale.businessSettings',
      component: () => import(/* webpackChunkName: "" */ '@/modules/company/components/business-settings/BusinessSettings'),
      meta: {
        title: 'Prodajna mjesta i blagajne',
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/orderman',
      name: 'pointOfSale.orderman',
      component: () => import(/* webpackChunkName: "OrdermanSettings" */ '@/modules/company/components/orderman/OrdermanSettings'),
      meta: {
        title: 'Orderman',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'PointOfSale',
        topBar: 'PointOfSaleTopBar'
      }
    }
  ]
}
